<template>
    <BaseEditPage
        :context="context"
        :alvqa="alvqa"
        cancelIconRoute="/dashboard"
    >
        <!-- HEADLINE  -->    
        <template v-slot:headline>
            <div :alvqa="alvqa + '-title'">
                {{ $t('lang_ACCOUNT_COMPANIES_CAPTION_YOUR_CUSTOMER_DATA') }}
            </div>
        </template> 

        <!-- EDIT FORM  -->
        <template v-slot:editForm>
            <v-container>
                <v-row>

                    <!-- Column 1 -->
                    <v-col cols="3">
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="CompanyName"
                                :label="$t('lang_GENERAL_CAPTION_COMPANY')"
                                :disabled="true"
                                :alvqa="alvqa + '-dropdown-company-name'"
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Salutation1"
                                :label="$t('lang_AZ_PERSONS_CAPTION_SALUTATION_ADDRESS')"
                                :alvqa="alvqa + '-dropdown-salutation-1'"
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Firstname"
                                :label="$t('lang_AZ_PERSONS_CAPTION_FIRST_NAME')"
                                :alvqa="alvqa + '-dropdown-first-name'"
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Lastname"
                                :label="$t('lang_AZ_PERSONS_CAPTION_LAST_NAME')"
                                :alvqa="alvqa + '-dropdown-last-name'"
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="AddressRow1"
                                :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_1')"
                                :alvqa="alvqa + '-dropdown-address-row-1'"
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="AddressRow2"
                                :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_2')"
                                :alvqa="alvqa + '-dropdown-address-row-2'"                                
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Zip"
                                :label="$t('lang_AZ_PERSONS_CAPTION_ZIP')"
                                :alvqa="alvqa + '-dropdown-zip'"                                
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="City"
                                :label="$t('lang_AZ_PERSONS_CAPTION_CITY')"
                                :alvqa="alvqa + '-dropdown-city'"                                
                            />
                        </v-row>
                                <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="State"
                                :label="$t('lang_AZ_PERSONS_CAPTION_STATE')"
                                :alvqa="alvqa + '-dropdown-city'"                                
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageDropdown 
                                :context="context"
                                field="Country"
                                :items="dropdownCountries"
                                rules="required"
                                :label="$t('lang_AZ_PERSONS_CAPTION_COUNTRY')"
                                :alvqa="alvqa + '-dropdown-country'"
                            />
                        </v-row> 
                    </v-col>

                    <!-- Column 2 -->
                    <v-col cols="3">
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="CustomerNumber"
                                :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_CUSTOMER_NUMBER')"
                                :disabled="true"
                                :alvqa="alvqa + '-dropdown-customer-number'"
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Salutation2"
                                :label="$t('lang_AZ_PERSONS_CAPTION_SALUTATION_TEXT')"
                                :alvqa="alvqa + '-dropdown-salutation-2'"                                
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageDropdown 
                                :context="context"
                                field="FormalSalutation"
                                :items="dropdownFormalSalutation" 
                                :label="$t('lang_GENERIC_CAPTION_FORMAL_SALUTATION')"
                                :selection="true"
                                :clearable="false"
                                :alvqa="alvqa + '-dropdown-formal-salutation'"
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="AccountHolder"
                                :label="$t('lang_GENERIC_CAPTION_ACCOUNT_HOLDER')"
                                :alvqa="alvqa + '-dropdown-account-holder'"
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Iban"
                                :label="$t('lang_GENERAL_CAPTION_IBAN_ACCOUNT_NO')"
                                :alvqa="alvqa + '-dropdown-iban'"                                
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Bic"
                                :label="$t('lang_GENERAL_CAPTION_BIC_SWIFT_ABA')"
                                :alvqa="alvqa + '-dropdown-bic'"                                
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Email"
                                :label="$t('lang_AZ_PERSONS_CAPTION_EMAIL')"
                                :alvqa="alvqa + '-dropdown-email'"                                
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Cellphone"
                                :label="$t('lang_AZ_PERSONS_CAPTION_CELLPHONE')"
                                :alvqa="alvqa + '-dropdown-cellphone'"                                
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Phone"
                                :label="$t('lang_AZ_PERSONS_CAPTION_PHONE')"
                                :alvqa="alvqa + '-dropdown-phone'"                                
                            />
                        </v-row>

                    </v-col>

                    <!-- Column 3 -->
                    <v-col cols="3">
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="AlvCode"
                                :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_ALV_CODE')"
                                :disabled="true"
                                :alvqa="alvqa + '-dropdown-alv-code'"
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="AlvPackage"
                                :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_ALV_PACKAGE')"
                                :disabled="true"
                                :alvqa="alvqa + '-dropdown-alv-package'"                                
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="VatPercent"
                                :label="$t('lang_GENERIC_CAPTION_VAT')"
                                :disabled="true"
                                :alvqa="alvqa + '-dropdown-vat-percent'"                                
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageTextField 
                                :context="context"
                                field="SepaMandate"
                                :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_SEPA_MANDATE')"
                                :disabled="true"
                                :alvqa="alvqa + '-dropdown-sepa-mandate'"                                
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageDatePicker 
                                :context="context"
                                field="SepaMandateDate"
                                :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_SEPA_MANDATE_DATE')"
                                :alvqa="alvqa + '-datepicker-sepa-mandate-date'"
                                :disabled="true"
                            />
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="pt-0"><CompanyLogoUpload /></v-col>
                        </v-row>
                    </v-col>

                    <!-- Column 4 -->
                    <v-col cols="2">
                        <v-row>
                            <BaseEditPageDropdown 
                                :context="context"
                                field="Language"
                                :items="dropdownLanguages"
                                :label="$t('lang_GENERIC_CAPTION_LANGUAGE')"
                                :disabled="true"
                                :alvqa="alvqa + '-dropdown-language'"
                            />
                        </v-row>
                        <v-row>
                            <BaseEditPageDropdown 
                                :context="context"
                                field="NumberFormat"
                                :items="dropdownNumberFormats"
                                :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_NUMBER_FORMAT')"
                                :disabled="true"
                                :clearable="false"
                                :alvqa="alvqa + '-dropdown-number-format'"                                
                            />
                        </v-row>    
                        <v-row>
                            <BaseEditPageDropdown 
                                :context="context"
                                field="Currency"
                                :items="dropdownCurrencies"
                                :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_HOME_CURRENCY')"
                                :disabled="true"
                                :alvqa="alvqa + '-dropdown-currency'"                                
                            />
                        </v-row> 
                        <v-row>
                            <BaseEditPageDropdown 
                                :context="context"
                                field="HomeSocietyCode"
                                :items="dropdownSocieties"
                                :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_HOME_SOCIETY')"
                                :alvqa="alvqa + '-dropdown-home-society-code'"                                
                            />
                        </v-row> 
                        <v-row>
                            <v-text-field 
                                :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_ALV_VAULT')" 
                                v-model="storageInfo" 
                                class="ml-4 mr-4" 
                                :disabled="true"
                                :alvqa="alvqa + '-dropdown-alv-vault'"                                
                            />
                        </v-row>
                        <v-row>
                            <v-text-field 
                                :label="$t('lang_ACCOUNT_COMPANIES_CAPTION_ALV_DATA_SHARING_CODE')" 
                                v-model="dataSharingCode" 
                                class="ml-4 mr-4" 
                                :disabled="true"
                                :alvqa="alvqa + '-text-field-datasharing-code'"                                
                            />
                        </v-row>
                    </v-col>

                </v-row>
            </v-container>
        </template>

        <!-- PANELS -->
        <template v-slot:panels>
            <!-- <UploadPictureDialog /> -->
            <ImageUploadDialog
               headline="lang_GENERAL_LOGO_UPLOAD_DIALOG_TITLE"
            />
            <PayableConfirmationDialog />
            <PublishingCompaniesPanel />
            <PublishingCompaniesEditPanelDialog />
            <LabelCompaniesPanel />
            <LabelCompaniesEditPanelDialog />
            <InvoicesPanel />
            <CompanyDefaultMappingsDialog />
        </template>
    </BaseEditPage>
</template>

<script>
import CompanyLogoUpload from '@/components/CompanyLogoUpload'
import BaseEditPage from '@/components/_base/BaseEditPage'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import PublishingCompaniesPanel from './_panels/PublishingCompaniesPanel'
import PublishingCompaniesEditPanelDialog from './_panels/PublishingCompaniesEditPanelDialog'
import LabelCompaniesPanel from './_panels/LabelCompaniesPanel'
import LabelCompaniesEditPanelDialog from './_panels/LabelCompaniesEditPanelDialog'
import PayableConfirmationDialog from './_dialogs/PayableConfirmationDialog'
import CompanyDefaultMappingsDialog from './_dialogs/CompanyDefaultMappingsDialog'
import ImageUploadDialog from '@/components/_dialogs/ImageUploadDialog'

import InvoicesPanel from './_panels/InvoicesPanel'
import {    DropdownFormalSalutation,
            DropdownCompaniesRoles,
            DropdownErpInvoicesLanguages,
            DropdownCurrencies,
            DropdownNumberFormats,
            } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "CompaniesEdit",
    components: {
        CompanyLogoUpload,
        BaseEditPage,
        BaseEditPageTextField,
        BaseEditPageDropdown,
        BaseEditPageDatePicker,
        PayableConfirmationDialog,
        CompanyDefaultMappingsDialog,

        PublishingCompaniesPanel,
        PublishingCompaniesEditPanelDialog,
        LabelCompaniesPanel,
        LabelCompaniesEditPanelDialog,
        ImageUploadDialog,
        InvoicesPanel,
    },
    data() {
        return {
            context: "Account",
            alvqa: "account-companies-edit-form",
        }
    },
    computed: {
        dropdownFormalSalutation()  { return DropdownFormalSalutation },
        dropdownRoles()             { return DropdownCompaniesRoles },
        dropdownLanguages()         { return DropdownErpInvoicesLanguages },
        dropdownCurrencies()        { return DropdownCurrencies },
        dropdownNumberFormats()     { return DropdownNumberFormats },
        dropdownCountries()         { return this.$alvPlugin.getListOfTranslatedCountries() },
        dropdownSocieties()         { 
            let societies = this.$store.getters.getSocieties
            // setting alvqa for GI Tests and reformatting to change society codes in dropdown
            societies.forEach(society => { society['alvqa'] = this.alvqa + '-dropdown-society-' + society.value })
            // sorting with js before 
            societies.sort((a,b) => (a.text > b.text) ? 1 : (b.text > a.text) ? -1 : 0)
            return societies
         },
         storageInfo() {
             let storageUsed        = this.$n(this.$store.getters.getAccountDetailsStorageUsed, 'number')
             let storageAvailable   = this.$store.getters.getAccountDetailsStorageAvailable
             return storageUsed + " MB " + this.$t('lang_GENERIC_CAPTION_OF') + " " + storageAvailable
         },
         dataSharingCode() {
            return this.$store.getters.getAccountDetails.dataSharingCode
         }
    },
    methods: {
        openPayableConfirmationDialog(item) {
            if(item.companyType === 'publishing-company') 
                this.$store.commit('setPayableConfirmationDialogText', 'lang_ACCOUNT_COMPANIES_DIALOG_ADD_PUBLISHING_COMPANY')
            elseif (item.companyType === 'label-company')
                this.$store.commit('setPayableConfirmationDialogText', 'lang_ACCOUNT_COMPANIES_DIALOG_ADD_LABEL_COMPANY')
            
            // needs to be set so that the dialog is able to change the status back if user clicks cancel/no
            this.$store.commit('setSelectedPayableConfirmation', item)
            this.$store.commit('setShowPayableConfirmationDialog', true)
        },
    },
    created() {
        this.$store.commit('setSocieties')
        this.$store.commit('setCountries')
    }
}
</script>